import React from 'react'
// libs
import { useDispatch, useSelector } from 'react-redux'
// components
import { Button, BUTTON_LAYOUTS, PopoverModal } from 'components/UI'
// view components
import { DashboardsMenu } from 'components/CTAs/AddDashboardButton/components/DashboardsMenu'
// themes
import { colors } from 'themes/index'
// store
import { isDashboardEditSelector, updateDashboard, currentDashboardSelector } from 'store/reducers/dashboards'

const BUTTON_STYLE = {
  color: colors.purple300,
  height: '40px'
}

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'center' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'center' as const
  },
  PaperProps: {
    style: { marginTop: '24px' }
  }
}

const AddDashboardButton: React.FC = () => {
  const dispatch = useDispatch()

  const isEdit = useSelector(isDashboardEditSelector)
  const currentDashboard = useSelector(currentDashboardSelector)

  const onDashboardEditDone = (dashboardId: string) => {
    dispatch(updateDashboard({ id: dashboardId, data: currentDashboardRef.current }))
  }

  const currentDashboardRef = React.useRef(null)

  React.useEffect(() => {
    currentDashboardRef.current = currentDashboard
  }, [currentDashboard])

  return (
    <PopoverModal
      {...MODAL_PROPS}
      trigger={
        <Button disabled={isEdit} shadowLess layout={BUTTON_LAYOUTS.DARK_BLUE} type='button' style={BUTTON_STYLE}>
          {currentDashboard?.title || 'ADD'}
        </Button>
      }>
      {({ closePopup }) => <DashboardsMenu closePopup={closePopup} onDashboardEditDone={onDashboardEditDone} />}
    </PopoverModal>
  )
}

export default AddDashboardButton
